"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseUnitConfigs = exports.math = exports.DerivedDimensionEnum = exports.BaseDimensionEnum = void 0;

var mathjs = _interopRequireWildcard(require("mathjs"));

var _mathDateFunctions = require("./math-date-functions");

var _baseUnitConfigs;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BaseDimensionEnum;
exports.BaseDimensionEnum = BaseDimensionEnum;

(function (BaseDimensionEnum) {
  BaseDimensionEnum["CURRENT"] = "CURRENT";
  BaseDimensionEnum["LENGTH"] = "LENGTH";
  BaseDimensionEnum["MASS"] = "MASS";
  BaseDimensionEnum["TEMPERATURE"] = "TEMPERATURE";
  BaseDimensionEnum["TIME"] = "TIME";
  BaseDimensionEnum["AMOUNT_OF_SUBSTANCE"] = "AMOUNT_OF_SUBSTANCE";
  BaseDimensionEnum["BACTERIA_COUNT"] = "BACTERIA_COUNT";
  BaseDimensionEnum["CURRENCY_EURO"] = "CURRENCY_EURO";
  BaseDimensionEnum["CURRENCY_USD"] = "CURRENCY_USD";
  BaseDimensionEnum["FIBER_CONCENTRATION"] = "FIBER_CONCENTRATION";
  BaseDimensionEnum["PERCENT_SURVIVAL"] = "PERCENT_SURVIVAL";
  BaseDimensionEnum["PERCENT_VOLUME"] = "PERCENT_VOLUME";
  BaseDimensionEnum["PERCENT_WEIGHT"] = "PERCENT_WEIGHT";
  BaseDimensionEnum["PH"] = "PH";
  BaseDimensionEnum["RADIOACTIVITY"] = "RADIOACTIVITY";
  BaseDimensionEnum["SOUND"] = "SOUND";
  BaseDimensionEnum["TOXICITY"] = "TOXICITY";
  BaseDimensionEnum["TURBIDITY"] = "TURBIDITY";
  BaseDimensionEnum["ANGLE"] = "ANGLE";
  BaseDimensionEnum["BIT"] = "BIT";
  BaseDimensionEnum["LUMINOUS_INTENSITY"] = "LUMINOUS_INTENSITY";
})(BaseDimensionEnum || (exports.BaseDimensionEnum = BaseDimensionEnum = {}));

var DerivedDimensionEnum;
exports.DerivedDimensionEnum = DerivedDimensionEnum;

(function (DerivedDimensionEnum) {
  DerivedDimensionEnum["ENERGY"] = "ENERGY";
  DerivedDimensionEnum["FREQUENCY"] = "FREQUENCY";
  DerivedDimensionEnum["NONE"] = "NONE";
  DerivedDimensionEnum["POWER"] = "POWER";
  DerivedDimensionEnum["PRESSURE"] = "PRESSURE";
  DerivedDimensionEnum["SURFACE"] = "SURFACE";
  DerivedDimensionEnum["VOLUME"] = "VOLUME";
  DerivedDimensionEnum["BACTERIA_COUNT_PER_MASS"] = "BACTERIA_COUNT_PER_MASS";
  DerivedDimensionEnum["BACTERIA_COUNT_PER_VOLUME"] = "BACTERIA_COUNT_PER_VOLUME";
  DerivedDimensionEnum["CONCENTRATION_SOLIDS_IN_LIQUID"] = "CONCENTRATION_SOLIDS_IN_LIQUID";
  DerivedDimensionEnum["LENGTH_SQUARE_ROOT"] = "LENGTH_SQUARE_ROOT";
  DerivedDimensionEnum["ELECTRIC_CAPACITANCE"] = "ELECTRIC_CAPACITANCE";
  DerivedDimensionEnum["ELECTRIC_CHARGE"] = "ELECTRIC_CHARGE";
  DerivedDimensionEnum["ELECTRIC_CONDUCTANCE"] = "ELECTRIC_CONDUCTANCE";
  DerivedDimensionEnum["ELECTRIC_INDUCTANCE"] = "ELECTRIC_INDUCTANCE";
  DerivedDimensionEnum["ELECTRIC_POTENTIAL"] = "ELECTRIC_POTENTIAL";
  DerivedDimensionEnum["ELECTRIC_RESISTANCE"] = "ELECTRIC_RESISTANCE";
  DerivedDimensionEnum["FORCE"] = "FORCE";
  DerivedDimensionEnum["MAGNETIC_FLUX"] = "MAGNETIC_FLUX";
  DerivedDimensionEnum["MAGNETIC_FLUX_DENSITY"] = "MAGNETIC_FLUX_DENSITY";
})(DerivedDimensionEnum || (exports.DerivedDimensionEnum = DerivedDimensionEnum = {}));

var PrefixTypeEnum; // Different prefix types have different prefixes,
// e.g. LONG prefix type includes "kilo", "milli", "micro", etc. SHORT includes "k", "m", "u", etc.
// '' for no prefix

(function (PrefixTypeEnum) {
  PrefixTypeEnum["NONE"] = "NONE";
  PrefixTypeEnum["SHORT"] = "SHORT";
  PrefixTypeEnum["LONG"] = "LONG";
  PrefixTypeEnum["SQUARED"] = "SQUARED";
  PrefixTypeEnum["CUBIC"] = "CUBIC";
  PrefixTypeEnum["BINARY_SHORT_SI"] = "BINARY_SHORT_SI";
  PrefixTypeEnum["BINARY_SHORT_IEC"] = "BINARY_SHORT_IEC";
  PrefixTypeEnum["BINARY_LONG_SI"] = "BINARY_LONG_SI";
  PrefixTypeEnum["BINARY_LONG_IEC"] = "BINARY_LONG_IEC";
  PrefixTypeEnum["BTU"] = "BTU";
  PrefixTypeEnum["SHORTLONG"] = "SHORTLONG";
  PrefixTypeEnum["BINARY_SHORT"] = "BINARY_SHORT";
  PrefixTypeEnum["BINARY_LONG"] = "BINARY_LONG";
  PrefixTypeEnum["ROMAN_NUMERALS"] = "ROMAN_NUMERALS";
  PrefixTypeEnum["ROMAN_NUMERALS_WITH_STANDARD"] = "ROMAN_NUMERALS_WITH_STANDARD";
  PrefixTypeEnum["THOUSAND_MILLION"] = "THOUSAND_MILLION";
})(PrefixTypeEnum || (PrefixTypeEnum = {}));

/*
  Instantiating math instance
 */
var mathInstance = mathjs.create(mathjs.all); // Extending math.js instance with custom functions

var options = {
  // If mathjs already has a function with the same name, our custom function will override it.
  // We shouldn't name our function the same way as existing ones,
  // unless we indeed want a different implementation for the same functionality.
  // This option is a safeguard in case we upgrade mathjs, and it has introduced a new function
  // with the same name as our custom one.
  override: true
};
mathInstance["import"](_mathDateFunctions.dateFunctions, options);
var math = mathInstance;
/*
  Extending math.js to accept underscore ("_") as valid character for units
  in addition to digits and latin letters.
  https://mathjs.org/docs/datatypes/units.html#userdefined-units

  - Mathjs units can't have spaces in their names,
    e.g. in formula expression, "fluid ounces" will be parsed as two units: "fluid" and "ounces".
  - Mathjs units can't have characters in their names that can be confused with mathematical operations,
    e.g. "*", "/", "+", "-", "%", etc.
  - Mathjs unit must start with a letter or "_", it can't start with a number,
    e.g. in formula expression, "32_lbs_bucket" will be parsed as a "32" number and a "_lbs_bucket" unit.
 */

exports.math = math;
var isValidAlphaOriginal = math.Unit.isValidAlpha;

math.Unit.isValidAlpha = function isValidAlpha(_char) {
  return isValidAlphaOriginal(_char) || _char === '_';
};
/*
  Extending math.js with roman numeral prefixes (e.g. for CCF, MCF, MMCF)
 */


math.Unit.PREFIXES[PrefixTypeEnum.ROMAN_NUMERALS] = {
  '': {
    name: '',
    value: 1,
    scientific: false
  },
  C: {
    name: 'C',
    value: 1e2,
    scientific: false
  },
  M: {
    name: 'M',
    value: 1e3,
    scientific: false
  },
  MM: {
    name: 'MM',
    value: 1e6,
    scientific: false
  },
  B: {
    name: 'B',
    value: 1e9,
    scientific: false
  },
  T: {
    name: 'T',
    value: 1e12,
    scientific: false
  },
  Q: {
    name: 'Q',
    value: 1e15,
    scientific: false
  }
};
math.Unit.PREFIXES[PrefixTypeEnum.ROMAN_NUMERALS_WITH_STANDARD] = _objectSpread({
  S: {
    name: 'S',
    value: 1,
    scientific: false
  }
}, math.Unit.PREFIXES[PrefixTypeEnum.ROMAN_NUMERALS]);
math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION] = {
  '': {
    name: '',
    value: 1,
    scientific: false
  },
  hundred_: {
    name: 'hundred_',
    value: 1e2,
    scientific: false
  },
  thousand_: {
    name: 'thousand_',
    value: 1e3,
    scientific: false
  },
  million_: {
    name: 'million_',
    value: 1e6,
    scientific: false
  }
}; // Adding our prefixes to mathjs unit definition, so users could type "thousand_ft" or "million_gal"

if (math.Unit.UNITS.ft) {
  math.Unit.UNITS.ft.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}

if (math.Unit.UNITS.foot) {
  math.Unit.UNITS.foot.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}

if (math.Unit.UNITS.feet) {
  math.Unit.UNITS.feet.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}

if (math.Unit.UNITS.gal) {
  math.Unit.UNITS.gal.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}

if (math.Unit.UNITS.gallon) {
  math.Unit.UNITS.gallon.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}

if (math.Unit.UNITS.gallons) {
  math.Unit.UNITS.gallons.prefixes = math.Unit.PREFIXES[PrefixTypeEnum.THOUSAND_MILLION];
}
/*
  Extending math.js with mapistry specific units
  https://mathjs.org/docs/datatypes/units.html#userdefined-units
 */


var unitsToCreate = {
  // Mass
  bone_dry_tons: {
    definition: '1 ton',
    aliases: ['BDT', 'bone_dry_ton']
  },
  bone_dry_units: {
    definition: '1.2 ton',
    aliases: ['BDU', 'bone_dry_unit']
  },
  bucket32lbs: {
    definition: '32 lbs',
    aliases: ['bucket_32_lbs']
  },
  oven_dry_ton: {
    definition: '1 ton',
    aliases: ['oven_dry_tons']
  },
  metric_tons: {
    definition: '1 tonne',
    aliases: ['metric_ton']
  },
  // Length
  linear_ft: {
    definition: '1 ft',
    prefixes: PrefixTypeEnum.THOUSAND_MILLION,
    aliases: ['linear_foot, linear_feet']
  },
  VMT: {
    definition: '1 mile',
    aliases: ['vehicle_miles_traveled', 'vehicle_mile_traveled']
  },
  // Length square root
  sqrt_ft: {
    definition: '1 ft^0.5',
    baseName: DerivedDimensionEnum.LENGTH_SQUARE_ROOT
  },
  // Area
  ft2: {
    // mathjs defines m2 as shortcut for m^2, doing the same for ft^2
    definition: '1 ft^2',
    prefixes: PrefixTypeEnum.THOUSAND_MILLION,
    aliases: ['sq_feet', 'sq_foot', 'sq_ft', 'feet2']
  },
  SF: {
    definition: '1 ft^2',
    prefixes: PrefixTypeEnum.ROMAN_NUMERALS,
    aliases: ['sf']
  },
  // Volume
  barrel: {
    definition: '42 gallons',
    // NOTE: this overrides the built-in mathjs value for 'bbl' (mathjs uses that as an alias for "beerbarrel")
    aliases: ['barrels', 'bbl', 'oilbarrel', 'oilbarrels', 'obl']
  },
  beerbarrel: {
    definition: '31 gallons',
    aliases: ['beerbarrels']
  },
  BF: {
    definition: '144 in^3',
    // 1 ft * 1 ft * 1 in
    aliases: ['board_foot', 'board_feet', 'board_ft']
  },
  bucket5gals: {
    definition: '5 gallons',
    aliases: ['bucket_5_gal', 'bucket_5_gallons']
  },
  CF: {
    definition: '1 ft^3',
    prefixes: PrefixTypeEnum.ROMAN_NUMERALS_WITH_STANDARD,
    aliases: ['cf']
  },
  drum55gal: {
    definition: '55 gallons',
    aliases: ['drum_55_gal', 'drum_55_gallons']
  },
  fluid_ounce: {
    definition: '1 fluidounce',
    aliases: ['fluid_ounces', 'fl_oz']
  },
  ft3: {
    // mathjs defines m3 as shortcut for m^3, doing the same for ft^3
    definition: '1 ft^3',
    prefixes: PrefixTypeEnum.THOUSAND_MILLION,
    aliases: ['cubic_ft', 'cubic_foot', 'cubic_feet']
  },
  hogshead: {
    definition: '63 gallons',
    aliases: ['hogsheads']
  },
  // not just putting a prefix on BF because this is the only one used with it
  MBF: {
    definition: '1000 BF',
    aliases: ['thousand_board_feet', 'thousand_board_ft']
  },
  // "M" is a prefix, meaning "million" here, it's not standard, and "gal" seem to be used only with it,
  // that's why adding it here as a separate unit instead of defining "M" as a prefix.
  // "gal" unit already has other prefixes: thousand_gal, million_gal
  Mgal: {
    definition: '1000000 gallons'
  },
  Nm3: {
    definition: '1 m^3',
    aliases: ['Nm^3', 'normal_cubic_meter', 'normal_cubic_meters', 'normal_cubic_m']
  },
  quarts: {
    definition: '.25 gallon',
    aliases: ['quart', 'qt', 'qts']
  },
  // Flow rate (volume per time)
  SCFM: {
    definition: '1 SCF / minute'
  },
  // Pressure
  inHg: {
    definition: '25.4 mmHg',
    aliases: ['in_Hg', 'in_mercury', 'in_of_mercury']
  },
  inH2O: {
    definition: '25.4 mmH2O',
    aliases: ['in_water']
  },
  PSI: {
    definition: '1 psi'
  },
  // Power
  horsepower: {
    // mathjs uses imperial horsepower that we need (metric horsepower is slightly different)
    definition: '1 hp'
  },
  // Energy
  therm: {
    definition: '100000 BTU',
    aliases: ['thm', 'therms']
  },
  // Cubic feet of gas is no longer converted to BTUs of therms because conversion rate
  // depends on various factors like temperature and gas mixture.
  // User will have to specify their own conversion rate.
  // Electric conductance
  mho: {
    definition: '1 siemens',
    prefixes: PrefixTypeEnum.SHORT,
    aliases: ['mhos']
  },
  // Concentration solids in liquid
  PPM: {
    definition: '1 mg/L',
    baseName: DerivedDimensionEnum.CONCENTRATION_SOLIDS_IN_LIQUID
  },
  mass_concentration: {
    definition: '0.0001 g/ml'
  },
  percent_mass_in_water: {
    definition: '0.01 g/ml'
  },
  percent_weight_per_volume: {
    definition: '0.01 g/ml'
  },
  PPB: {
    definition: '0.001 PPM'
  },
  PPT: {
    definition: '0.000001 PPM'
  },
  // Fiber Concentration
  FL: {
    definition: undefined,
    baseName: BaseDimensionEnum.FIBER_CONCENTRATION,
    aliases: ['fibers_per_liter']
  },
  MFL: {
    definition: '1000000 FL',
    aliases: ['million_fibers_per_liter']
  },
  // Percent by weight
  percent_weight: {
    definition: undefined,
    baseName: BaseDimensionEnum.PERCENT_WEIGHT,
    aliases: ['percent_wt', 'percent_weight_per_weight']
  },
  PPM_weight: {
    definition: '0.0001 percent_weight'
  },
  weight_concentration: {
    definition: '0.01 percent_weight'
  },
  // Percent by volume
  percent_volume: {
    definition: undefined,
    baseName: BaseDimensionEnum.PERCENT_VOLUME,
    aliases: ['percent_vol', 'percent_volume_per_volume']
  },
  PPM_vol: {
    definition: '0.0001 percent_volume',
    aliases: ['PPM_volume']
  },
  volume_concentration: {
    definition: '0.01 percent_volume'
  },
  // % Survival (water suite)
  percent_survival: {
    definition: undefined,
    baseName: BaseDimensionEnum.PERCENT_SURVIVAL
  },
  // Bacteria count
  CFU: {
    definition: undefined,
    baseName: BaseDimensionEnum.BACTERIA_COUNT,
    prefixes: PrefixTypeEnum.THOUSAND_MILLION,
    aliases: ['colony_forming_units', 'cfu']
  },
  CNT: {
    definition: '1 CFU',
    aliases: ['bacteria_cnt', 'bacteria_count']
  },
  colonies: {
    definition: '1 CFU',
    aliases: ['col']
  },
  mpn: {
    definition: '1 CFU',
    aliases: ['MPN', 'most_probable_number']
  },
  // Bacteria count per volume
  CFU_per_100ml: {
    definition: '0.01 CFU/ml',
    baseName: DerivedDimensionEnum.BACTERIA_COUNT_PER_VOLUME,
    aliases: ['CFU_per_100mL', 'cfu_per_100ml', 'cfu_per_100mL']
  },
  CNT_per_100ml: {
    definition: '0.01 CNT/ml',
    aliases: ['CNT_per_100mL', 'cnt_per_100ml', 'cnt_per_100mL']
  },
  col_per_100ml: {
    definition: '0.01 colonies/ml',
    aliases: ['col_per_100mL', 'colonies_per_100ml', 'colonies_per_100mL']
  },
  mpn_per_100ml: {
    definition: '0.01 mpn/ml',
    aliases: ['mpn_per_100mL', 'MPN_per_100ml', 'MPN_per_100mL']
  },
  // Bacteria count per weight
  CFU_per_gram: {
    definition: '1 CFU/g',
    baseName: DerivedDimensionEnum.BACTERIA_COUNT_PER_MASS,
    aliases: ['CFU_per_g', 'cfu_per_gram', 'cfu_per_g']
  },
  CNT_per_gram: {
    definition: '1 CNT/g',
    aliases: ['CNT_per_g', 'cnt_per_gram', 'cnt_per_g']
  },
  col_per_gram: {
    definition: '1 colonies/g',
    aliases: ['col_per_g', 'coliforms_per_gram', 'coliforms_per_g']
  },
  mpn_per_gram: {
    definition: '1 mpn/g',
    aliases: ['mpn_per_g', 'MPN_per_gram', 'MPN_per_g']
  },
  // Turbidity
  NTU: {
    definition: undefined,
    baseName: BaseDimensionEnum.TURBIDITY
  },
  // Radioactivity
  becquerel: {
    definition: undefined,
    baseName: BaseDimensionEnum.RADIOACTIVITY,
    prefixes: PrefixTypeEnum.LONG
  },
  Bq: {
    definition: "1 becquerel",
    prefixes: PrefixTypeEnum.SHORT
  },
  curie: {
    definition: "37 GBq",
    prefixes: PrefixTypeEnum.LONG,
    aliases: ['curies']
  },
  Ci: {
    definition: "37 GBq",
    prefixes: PrefixTypeEnum.SHORT
  },
  // pH
  SU: {
    definition: undefined,
    baseName: BaseDimensionEnum.PH
  },
  // Toxicity
  TUa: {
    // Acute Toxic Uit
    definition: undefined,
    baseName: BaseDimensionEnum.TOXICITY
  },
  // Different currencies
  EURO: {
    definition: undefined,
    baseName: BaseDimensionEnum.CURRENCY_EURO
  },
  USD: {
    definition: undefined,
    baseName: BaseDimensionEnum.CURRENCY_USD
  },
  // Amount of substance, extended
  g_mol: {
    definition: '1 mol',
    aliases: ['g_mole', 'g_moles']
  },
  lb_mol: {
    definition: '1 lb / g * mol',
    // lb-mol ~= 453.59 g-mol (same conversion factor as lb to g)
    aliases: ['lb_mole', 'lb_moles']
  },
  // Logarithmic ratio quantity
  // see https://en.wikipedia.org/wiki/Decibel & https://en.wikipedia.org/wiki/International_System_of_Units#Non-SI_units_accepted_for_use_with_SI
  decibel: {
    definition: undefined,
    baseName: BaseDimensionEnum.SOUND,
    aliases: ['decibels', 'dB']
  }
};
math.createUnit(unitsToCreate, {
  override: true
});
/*
  Defining storage units for each base dimension.

  math.js doesn't have a list of base units, it doesn't need to know which exact unit is a base one,
  it only needs to know how to convert to base dimension.
  We, on the other hand, do need to know the name of the unit itself
  in order to convert a given unit to a storage unit.
  A base unit configurations have all zeros and a single "1" in its DimensionArray.
  We can't find such base unit from a list of unit configurations (math.Unit.UNITS)
  because it includes all aliases, e.g. it will have config for "meter", "meters" and "m".
  For the sake of determinism, we specify which of unit config to use as a base unit explicitly.
 */

var UNITS = math.Unit.UNITS;
var nonePrefix = {
  name: '',
  value: 1,
  scientific: true
}; // This list is in order how they appear in DimensionArray.

var baseUnitConfigs = (_baseUnitConfigs = {}, _defineProperty(_baseUnitConfigs, BaseDimensionEnum.MASS, {
  unit: UNITS.g,
  // kilogram
  prefix: {
    name: 'k',
    value: 1000,
    scientific: true
  }
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.LENGTH, {
  unit: UNITS.m,
  // meter
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.TIME, {
  unit: UNITS.s,
  // second
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.CURRENT, {
  unit: UNITS.A,
  // Ampere
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.TEMPERATURE, {
  unit: UNITS.K,
  // Kelvin
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.LUMINOUS_INTENSITY, {
  unit: UNITS.cd,
  // Candela
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.AMOUNT_OF_SUBSTANCE, {
  unit: UNITS.mol,
  // Mole
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.ANGLE, {
  unit: UNITS.rad,
  // radian
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.BIT, {
  unit: UNITS.b,
  // Bit
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.FIBER_CONCENTRATION, {
  unit: UNITS.FL,
  // Fiber per liter
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.PERCENT_WEIGHT, {
  unit: UNITS.percent_weight,
  // % weight (water suite)
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.PERCENT_VOLUME, {
  unit: UNITS.percent_volume,
  // % volume (water suite)
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.PERCENT_SURVIVAL, {
  unit: UNITS.percent_survival,
  // % survival (water suite)
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.BACTERIA_COUNT, {
  unit: UNITS.CFU,
  // Colony Forming Units
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.TURBIDITY, {
  unit: UNITS.NTU,
  // NTU
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.RADIOACTIVITY, {
  unit: UNITS.Bq,
  // becquerel
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.PH, {
  unit: UNITS.SU,
  // becquerel
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.TOXICITY, {
  unit: UNITS.TUa,
  // Acute Toxic Unit
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.CURRENCY_EURO, {
  unit: UNITS.EURO,
  // Euro
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.CURRENCY_USD, {
  unit: UNITS.USD,
  // US dollar
  prefix: nonePrefix
}), _defineProperty(_baseUnitConfigs, BaseDimensionEnum.SOUND, {
  unit: UNITS.decibel,
  prefix: nonePrefix
}), _baseUnitConfigs);
exports.baseUnitConfigs = baseUnitConfigs;